import {Breadcrumb, Card, Col, Layout, message, Row,Tabs,} from 'antd'
import React, { useEffect, useState } from 'react'
import {EditOutlined} from '@ant-design/icons'
import OAMSider from '../../oam-sider'
import { Content } from 'antd/lib/layout/layout'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { sendHttpPostRequest } from '@/api/http-request'
import css from './dataset-detail.module.less'
import GlobalCss from '@/global.module.less'


import { FileList } from '@/pages/case/CaseDetail/FileList'
import PublicDatasetFormModal from '../components/PublicDatasetFormModal/PublicDatasetFormModal'

function DatasetDetailPage() {
  const location = useLocation()
  const datasetId = location?.search?.split('id=')[1]
  const state: any = useLocation()?.state
  const dataType = state?.type
  const history = useHistory()
  const [datasetInfo, setDatasetInfo] = useState<any>()
  const [editModalVis, setEditModalVis] = useState(false)

  const getDatasetDetail = () => {
    let data = {
      dataset_id: datasetId,
    }
    sendHttpPostRequest('dataset/api/oam_get_dataset_by_id/', data, (res) => {
      if (res.code == 0) {
        setDatasetInfo(res.query_info)
      }
      if (res.code == -100) {
        message.error(res.message)
      }
    })
  }

  useEffect(() => {
    getDatasetDetail()
    return () => {}
  }, [])

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <OAMSider keys={['88']} openKeys={[]} />

      <Layout style={{ backgroundColor: '#f9f9f9', padding: '20px 30px' }}>
        <Breadcrumb style={{ marginBottom: '0' }}>
          {dataType == 'public' ? (
            <Breadcrumb.Item
              className={GlobalCss.link}
              onClick={() =>
                history.push('/oam_dataset_list', { type: 'public' })
              }
            >
              {' '}
              公共数据集
            </Breadcrumb.Item>
          ) : dataType == 'exercise' ?  (
            <Breadcrumb.Item
              className={GlobalCss.link}
              onClick={() =>
                history.push('/oam_dataset_list', { type: 'exercise' })
              }
            >
              {' '}
              习题数据集
            </Breadcrumb.Item>
          ) : 
          (
            <Breadcrumb.Item
              className={GlobalCss.link}
              onClick={() =>
                history.push('/oam_dataset_list', { type: 'case' })
              }
            >
              {' '}
              实验数据集
            </Breadcrumb.Item>
          )}
          <Breadcrumb.Item>数据集详情</Breadcrumb.Item>
        </Breadcrumb>
        <Content
          style={{
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 400,
          }}
        >
          <Card
            style={{ height: '100%', border:'0px' }}
            title={
              <Row align={'middle'} justify={'start'} style={{ gap: '10px' }}>
                <Col>{datasetInfo?.title}</Col>
                {dataType != 'public' ? (
                  ''
                ) : (
                  <Col>
                    <div
                      className={GlobalCss.btnBox}
                      onClick={() => setEditModalVis(true)}
                    >
                      <EditOutlined style={{fontSize:16, color:'#666'}}/>
                    </div>
                  </Col>
                )}
              </Row>
            }
          >
            <div className={css.headerFlex}>
              <Row align={'middle'}>
                <Col>创建时间：</Col>
                <Col>{datasetInfo?.create_time}</Col>
              </Row>
              <Row align={'middle'}>
                <Col>描述：</Col>
                <Col>{datasetInfo?.description}</Col>
              </Row>
            </div>

            <Tabs
              items={[
                {
                  label: '数据文件',
                  key: 'data_file',
                  children: datasetInfo && (
                    <FileList 
                    datasetInfo={datasetInfo} 
                    requestType='oam'
                    dataset_id = {datasetInfo?.id}/>
                  ),
                },
              ]}
            ></Tabs>
          </Card>
        </Content>
        {datasetInfo && (
          <PublicDatasetFormModal
            mode={'edit'}
            open={editModalVis}
            setOpen={setEditModalVis}
            actionCallback={getDatasetDetail}
            actionDataset={datasetInfo}
          />
        )}
      </Layout>
    </Layout>
  )
}

export default DatasetDetailPage
